import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton"];

  connect() {
    this.columns = this.element.querySelectorAll(".form-field");
    setTimeout(() => this.toggleSubmitButton(), 0);
    setTimeout(() => this.toggleSubmitButton(), 100);
  }

  validate(e) {
    let isValid;
    if (e.target.type === "hidden" && e.target.hasAttribute("required")) {
      isValid = e.target.value && e.target.value.trim() !== "";
    } else {
      isValid = e.target.checkValidity();
    }

    const formGroup = e.target.closest(".form-group");
    const errorMessageBlock = formGroup?.querySelector(".error-message");

    if (errorMessageBlock) {
      if (isValid) {
        errorMessageBlock.textContent = "";
        e.target.classList.remove("is-error");
      } else {
        const message =
          e.target.type === "hidden" && e.target.hasAttribute("required")
            ? "この項目は必須です。"
            : this.getErrorMessage(e.target.validity, e.params);
        errorMessageBlock.textContent = message;
        e.target.classList.add("is-error");
      }
    }

    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    if (!this.hasSubmitButtonTarget) {
      return;
    }

    const fields = this.element.querySelectorAll(".form-field");
    const invalidFields = Array.from(fields).filter((field) => {
      if (field.type === "hidden" && field.hasAttribute("required")) {
        return !field.value || field.value.trim() === "";
      }
      return !field.checkValidity();
    });

    const hasInvalidField = invalidFields.length > 0;
    this.submitButtonTargets.forEach((btn) => {
      btn.disabled = hasInvalidField;
    });
  }

  getErrorMessage(validity, params) {
    if (validity.valueMissing) {
      return "この項目は必須です。";
    }
    if (validity.patternMismatch && params.patternMismatchMessage) {
      return params.patternMismatchMessage;
    }
    if (validity.typeMismatch && params.typeMismatchMessage) {
      return params.typeMismatchMessage;
    }
    if (validity.tooLong) {
      return "文字数が上限を超えています。";
    }

    return this.element.validationMessage;
  }

  disableRequiredAndSubmit(e) {
    e.preventDefault();
    this.columns.forEach((column) => column.removeAttribute("required"));
    this.element.submit();
  }
}
